import { IconActivity } from '@developerz/ui';
import { For, type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import type { UtilBox } from '../../lib/fleetUtilization';
import { RESOURCE_KINDS } from '../../lib/machine-bars';
import type { CardView } from '../../lib/machine-card';
import { MachineResourceBar } from '../MachineResourceBar';
import { HotSentence } from './HotSentence';
import { MoveMeter } from './MoveMeter';

// Resources (#6785, prototype resBars + hotHTML, `:2096-2105`, `:1919-1924`): the
// whole machine's CPU, Memory and Disk bars, each `resourceBar`'s number, fill and the
// server's tier, with its tooltip. "Unknown while offline" in their place when the machine
// is not checking in. Under them, for an admin, "Moves this minute" once the machine has used a
// move (#6772, `MoveMeter`), then, at 85% CPU or more, the machine with the most room.

export function ResourcesZone(props: {
  readonly box: UtilBox;
  readonly view: CardView;
}): JSX.Element {
  return (
    <section class="mission-zone" aria-label={t('fleet.machines.card_resources')}>
      <p class="mission-zone__label">
        <span>{t('fleet.machines.card_resources')}</span>
        <span class="mission-zone__side">{props.view.resources.side}</span>
      </p>
      <Show
        when={props.view.resources.bars !== null}
        fallback={<p class="mission-zone__quiet">{t('fleet.machines.card_unknown_offline')}</p>}
      >
        <div class="mission-card__bars">
          <For each={RESOURCE_KINDS}>
            {(kind) => <MachineResourceBar box={props.box} kind={kind} />}
          </For>
        </div>
      </Show>
      <MoveMeter />
      <Show when={props.view.resources.hot}>
        {(name) => (
          <p class="mission-card__hot">
            <IconActivity class="mission-card__hot-mark" />
            <HotSentence name={name()} />
          </p>
        )}
      </Show>
    </section>
  );
}
